/* =================== ANIMATE SCROLL =================== */

// Adiciona uma classe aos elementos após o mesmos serem exibidos na tela
function animeScroll(target, animationClass) {
  var documentTop = $(document).scrollTop();
  var windowHeight = $(window).height();
  var offset = windowHeight - windowHeight / 4;

  target.each(function () {
    eleTop = $(this).offset().top;
    if (documentTop > eleTop - offset) {
      $(this).addClass(animationClass);
    }
  });
}

$(function () {
  AOS.init({
    duration: 700,
    offset: 40,
  });
});

// Variáveis
const scrollAnimationOffset = 100;
const scrollAnimationDebounce = 50;

// Executa uma acão quando o elemento estiver visível na tela
function doWhenVisible($el, callback) {
  const $window = $(window);
  let executed = false;
  $window.on(
    "scroll",
    debounce(function () {
      checkVisibility();
    }, scrollAnimationDebounce)
  );
  // Verifica se o elemento está visível na tela
  function checkVisibility() {
    if (isElVisible($el)) {
      if (!executed) {
        callback();
        executed = true;
      }
    } else {
      executed = false;
    }
  }
  checkVisibility();
}

// Verifica se o elemento está visível na tela
function isElVisible($el) {
  const $window = $(window);
  const scrollTop = $window.scrollTop();
  const windowHeight = $window.height();
  const eleTop = $el.offset().top;
  return scrollTop + windowHeight > eleTop + scrollAnimationOffset;
}
